import { LoaderFunction } from 'react-router-dom';

// Utils
import { AuthContextType } from '../../../../hooks/useAuth';
import { decompressSessionStorage } from '../../../../utils/sessionStorage';
import { claimDraftScope } from '../../../../utils/draftOwnership';
import {
  ACCIDENT_CREATION_SCOPE,
  ACCIDENT_MEDIA_SCOPE,
  accidentCreationOwnerId,
} from '../../../../utils/draftScopes';
import { readAccidentCreationDraft } from '../../../../utils/accidentCreationDraft';

// Types
import { AddBasicInfoAccidentWithDynamicKeys } from './types';

// Constants
import { formVehicleNaming } from '../../../../components/forms/AddVehicleForm/constants';
import { Accident } from '../../../../types/accident';

export const VehicleLoader: (
  userData: AuthContextType | null
) => LoaderFunction | undefined = (userData) => async ({ params }) => {
  // 🔴 Dueño al llegar (S4; spec 2026-11-02 wizard-draft-ownership, I1): el
  // alta es de la OT/campaña de la URL, no de la que diga el borrador. Ver
  // `NewAccidentLoader`.
  const owner = accidentCreationOwnerId(params.id);
  claimDraftScope(ACCIDENT_CREATION_SCOPE, owner);
  claimDraftScope(ACCIDENT_MEDIA_SCOPE, owner);

  // El trabajo entero vive aquí dentro, íntegro. Solo ha dejado de
  // esperarse: la promesa tiene que llegar PENDIENTE al `<Await>` para que
  // el router termine la navegación al instante y el `<Fallback>` enseñe el
  // Loader DENTRO de la pantalla nueva.
  const load = async () => {
  // El padre sale de la URL: la copia del paso 1 solo vale si es suya. Antes
  // se tomaba `orderParentId` de la copia, fuera de quien fuera, y el
  // guardado creaba el accidente bajo ESE padre (auditoría § 4,
  // `AddVehicle/loader.ts:27-57`).
  const accidentData = readAccidentCreationDraft(params.id) as Accident | null;
  if (!accidentData || !userData) return null;

  const stringifyForm = sessionStorage.getItem(
    formVehicleNaming.NEW_VEHICLE_FORM
  );

  if (stringifyForm) {
    const sessionStorageData: AddBasicInfoAccidentWithDynamicKeys = JSON.parse(
      decompressSessionStorage(stringifyForm)
    );

    const combinedData = {
      ...sessionStorageData,
      orderParentRoid: accidentData.orderParentRoid,
      orderParentId: accidentData.orderParentId,
    };

    return combinedData;
  }

  return {
    orderParentRoid: accidentData.orderParentRoid,
    orderParentId: accidentData.orderParentId,
  };
};

  return { data: load() };
};
